import "./styles.css";
import "./site.css";
import { configured } from "./api.ts";
import { route, startRouter } from "./router.ts";

// Pages a parent reaches from a WhatsApp message, plus the front door. The tutor portal and the
// admin area come next; they live behind Supabase Auth and don't belong in this bundle.
route("/", async () => (await import("./pages/home.ts")).homePage());
route("/tutors", async () => (await import("./pages/tutors.ts")).tutorsPage());
route("/teach", async () => (await import("./pages/teach.ts")).teachPage());
route("/faq", async () => (await import("./pages/faq.ts")).faqPage());
route("/privacy", async () => (await import("./pages/legal.ts")).privacyPage());
route("/terms", async () => (await import("./pages/legal.ts")).termsPage());
route("/join", async () => (await import("./pages/join.ts")).joinPage());
route("/join/:token", async (p, q) => (await import("./pages/finish.ts")).finishPage(p, q));
route("/matches/:token", async (p) => (await import("./pages/matches.ts")).matchesPage(p));
route("/family/:token", async (p) => (await import("./pages/family.ts")).familyPage(p));
route("/tutors/:id", async (p) => (await import("./pages/tutor.ts")).tutorPage(p));
route("/book/:slug", async (p, q) => (await import("./pages/book.ts")).bookPage(p, q));
route("/book", async (p, q) => (await import("./pages/book.ts")).bookPage(p, q)); // /book?match=…
route("/pay/:id", async (p, q) => (await import("./pages/pay.ts")).payPage(p, q));
// The desk: behind Supabase Auth, and the database only answers to someone in `admins`.
route("/admin", async (p, q) => (await import("./pages/admin.ts")).adminPage(p, q));

// Without a Supabase project the site runs on the sample tutors, so it can be clicked through
// before anything is provisioned. Say so once, at the top, and never pretend otherwise.
if (!configured) {
  const strip = document.createElement("p");
  strip.className = "demo-strip";
  strip.innerHTML =
    '<b>Demo</b> · sample tutors, real matching · nothing is sent, booked or charged · ' +
    '<a href="/prototype.html">see the tutor\'s side</a>';
  document.querySelector(".site-head")!.after(strip);
}
// The only way to reach a person. It stays hidden until there's somewhere real to send them:
// a dead "WhatsApp us" is worse than no link at all, especially next to pages that say "message us".
const contact = import.meta.env.VITE_CONTACT_WHATSAPP as string | undefined;
const contactEmail = import.meta.env.VITE_CONTACT_EMAIL as string | undefined;
const link = document.getElementById("contact-link") as HTMLAnchorElement | null;
if (link && (contact || contactEmail)) {
  link.href = contact ? `https://wa.me/${contact.replace(/[^0-9]/g, "")}` : `mailto:${contactEmail}`;
  link.textContent = contact ? "WhatsApp us" : "Email us";
  link.removeAttribute("hidden");
}

startRouter();
